import React from 'react';
export function ProblemSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-179">
      <div className="max-w-3xl mx-auto" data-id="element-180">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-181">
          El problema que muchos docentes viven cada año
        </h2>

        <p className="text-xl mb-3 font-medium text-center md:text-left" data-id="element-182"></p>

        <ul className="space-y-2 text-lg text-gray-700 mb-5 max-w-2xl mx-auto" data-id="element-183">
          <li className="flex items-start" data-id="element-184">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-185">•</span>
            <span data-id="element-186">Pasás horas buscando efemérides en Internet</span>
          </li>
          <li className="flex items-start" data-id="element-187">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-188">•</span>
            <span data-id="element-189">Tenés material desactualizado</span>
          </li>
          <li className="flex items-start" data-id="element-190">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-191">•</span>
            <span data-id="element-192">Preparás actividades a último momento</span>
          </li>
          <li className="flex items-start" data-id="element-193">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-194">•</span>
            <span data-id="element-195">
              Repetís propuestas porque no hay tiempo para buscar nuevas
            </span>
          </li>
          <li className="flex items-start" data-id="element-196">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-197"></span>
            <span data-id="element-198"></span>
          </li>
        </ul>

        <p className="text-xl text-center mb-3 font-[800] text-[#3CD0E4]" data-id="element-199">
          Lo peor es esa sensación de pensar: "Podría trabajar mejor las
          efemérides… si tuviera todo el material organizado."
        </p>
      </div>
    </section>;
}